/* Private Supabase Broadcast only; persisted messages are always replayed by the caller.
 * Protocol: https://supabase.com/docs/guides/realtime/protocol (v1.0.0).
 * This module deliberately has no client broadcast/send API.
 */
(function (root) {
  'use strict';
  function connect(options) {
    var stopped = false, socket, reconnectTimer, heartbeatTimer, joinTimer;
    var attempt = 0, ref = 0, joinRef, heartbeatRef = null;
    var topic = 'realtime:chat:' + options.conversationId;
    function status(value) { if (!stopped && options.onStatus) options.onStatus(value); }
    function send(event, payload, channel) {
      var messageRef = String(++ref);
      socket.send(JSON.stringify({ topic: channel || topic, event: event, payload: payload, ref: messageRef, join_ref: channel ? null : joinRef }));
      return messageRef;
    }
    function cleanup() { clearInterval(heartbeatTimer); clearTimeout(joinTimer); heartbeatRef = null; }
    function open() {
      if (stopped) return;
      try {
        var url = new URL(options.url);
        if (url.protocol !== 'https:' || url.username || url.password || !options.token || !options.apiKey) throw new Error('Invalid realtime configuration');
        url.protocol = 'wss:';
        url.pathname = '/realtime/v1/websocket';
        url.search = '';
        url.searchParams.set('apikey', options.apiKey);
        url.searchParams.set('vsn', '1.0.0');
        socket = new WebSocket(url.toString());
      } catch (e) { status('unavailable'); return; }
      status('connecting');
      socket.onopen = function () {
        joinRef = String(ref + 1);
        send('phx_join', { config: { private: true, broadcast: { ack: false, self: false }, presence: { enabled: false }, postgres_changes: [] }, access_token: options.token });
        joinTimer = setTimeout(function () { socket.close(); }, 12000);
        heartbeatTimer = setInterval(function () {
          if (heartbeatRef) { socket.close(); return; }
          if (socket.readyState === 1) heartbeatRef = send('heartbeat', {}, 'phoenix');
        }, 25000);
      };
      socket.onmessage = function (event) {
        var message;
        try { message = JSON.parse(event.data); } catch (e) { return; }
        if (message.topic === 'phoenix' && message.ref === heartbeatRef) { heartbeatRef = null; return; }
        if (message.topic !== topic) return;
        if (message.event === 'phx_reply' && message.ref === joinRef) {
          clearTimeout(joinTimer);
          if (message.payload && message.payload.status === 'ok') { attempt = 0; status('connected'); }
          else { status('unauthorized'); socket.close(); }
        } else if (message.event === 'broadcast') {
          if (options.onMessage) options.onMessage(message.payload);
        } else if (message.event === 'phx_error' || message.event === 'phx_close') {
          socket.close();
        }
      };
      socket.onerror = function () { socket.close(); };
      socket.onclose = function () {
        cleanup();
        if (stopped) return;
        status('disconnected');
        reconnectTimer = setTimeout(open, Math.min(30000, 1000 * Math.pow(2, attempt++)) + Math.floor(Math.random() * 500));
      };
    }
    open();
    return { close: function () { stopped = true; clearTimeout(reconnectTimer); cleanup(); if (socket) socket.close(); } };
  }
  root.KSAgentRealtime = { connect: connect };
})(typeof window !== 'undefined' ? window : globalThis);
